document.addEventListener("DOMContentLoaded", function () {
  /** Megamenus */

  const secondaryMenu = document.querySelector(".menu-secondary-container");
  const secondaryMenuButtons = secondaryMenu?.querySelectorAll("button");
  const tertiaryMenus = document.querySelectorAll(".tertiary-menu");

  secondaryMenuButtons?.forEach((button) => {
    button.addEventListener("click", () => {
      const target = button.dataset.target;

      // Remove is-current class from all buttons
      secondaryMenuButtons.forEach((btn) => {
        btn.classList.remove("is-current");
      });

      // Add is-current class to clicked button
      button.classList.add("is-current");

      tertiaryMenus.forEach((menu) => {
        if (menu.id === target) {
          if (menu.classList.contains("is-active")) {
            menu.classList.remove("is-active");
            // If we're closing the menu, also remove the is-current class
            button.classList.remove("is-current");
          } else {
            menu.classList.add("is-active");
          }
        } else {
          menu.classList.remove("is-active");
        }
      });
    });
  });

  document.addEventListener("click", (event) => {
    // Check if the click is outside both the secondary menu AND all tertiary menus
    const clickedInsideTertiaryMenu = Array.from(tertiaryMenus).some((menu) =>
      menu.contains(event.target)
    );

    if (!secondaryMenu?.contains(event.target) && !clickedInsideTertiaryMenu) {
      tertiaryMenus.forEach((menu) => {
        menu.classList.remove("is-active");
      });

      // Remove is-current class from all buttons when clicking outside
      secondaryMenuButtons?.forEach((btn) => {
        btn.classList.remove("is-current");
      });
    }
  });

  /** Mobile menu */
  const mobileMenuToggle = document.querySelector("#toggle-menu-button");
  const mobileMenu = document.querySelector(".mobile__menu--container");

  mobileMenuToggle.addEventListener("click", () => {
    mobileMenu.classList.toggle("is-active");
  });

  /** Search bar */
  const searchBarToggle = document.querySelector("#toggle-search-button");
  const searchBar = document.querySelector("#search-bar");
  searchBarToggle.addEventListener("click", () => {
    searchBar.classList.toggle("is-active");
  });
});
